import Icon from '../components/Icon.vue'

Icon.register({
  strikethrough: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 288H16C7.2 288 0 280.8 0 272V240C0 231.2 7.2 224 16 224H496C504.8 224 512 231.2 512 240V272C512 280.8 504.8 288 496 288zM281.3 304C308.6 316.9 327.9 332.7 327.9 360.2 327.9 393.4 298.9 413.9 252.2 413.9 219.9 413.9 175.4 401.8 175.4 369.6V368C175.4 359.2 168.2 352 159.4 352H113.8C104.9 352 97.8 359.2 97.8 368V387.2C97.8 454 175.5 489 252.2 489 340.8 489 414.3 443.6 414.3 354.6 414.3 334.8 410.6 318.2 404.1 304H281.3zM250.4 208C218 194.5 193.5 179.1 193.5 148.3 193.5 114.4 224.4 100.9 258.5 100.9 301.2 100.9 323.5 117.5 323.5 133.9V136C323.5 144.8 330.6 152 339.5 152H385.1C393.9 152 401.1 144.8 401.1 136V105.7C401.1 53.2 329.4 25.8 258.5 25.8 173.3 25.8 107.8 66.8 107.8 151.5 107.8 174.2 112.4 192.6 120.6 208H250.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/strikethrough.js
// module id = 5HhZ
// module chunks = 144